import React, { memo } from 'react';
import { Brain } from 'lucide-react';
import { motion } from 'framer-motion';
export function Navbar() {
  return <motion.nav initial={{
    y: -100
  }} animate={{
    y: 0
  }} transition={{
    duration: 0.6,
    ease: 'easeOut'
  }} className="fixed top-0 left-0 right-0 z-50 bg-cerebro-dark/80 backdrop-blur-md border-b border-slate-800" data-id="element-98">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-20 flex items-center justify-between" data-id="element-99">
        <div className="flex items-center gap-3 cursor-pointer" onClick={() => window.scrollTo(0, 0)} data-id="element-100">
          <div className="relative" data-id="element-101">
            <Brain className="w-8 h-8 text-cerebro-blue" data-id="element-102" />
            <div className="absolute inset-0 bg-cerebro-blue blur-lg opacity-50 rounded-full" data-id="element-103"></div>
          </div>
          <span className="font-display font-bold text-xl tracking-tight text-white" data-id="element-104">
            Cerebro Rápido
          </span>
        </div>
        <a href="https://ideas-que-transforman-2.myshopify.com/products/metodo-m3-para-mejorar-la-memoria" target="_blank" rel="noopener noreferrer" className="hidden sm:inline-flex items-center justify-center px-6 py-2.5 text-sm font-semibold text-white transition-all duration-300 bg-cerebro-orange rounded-full shadow-[0_0_15px_rgba(249,115,22,0.4)] hover:shadow-[0_0_25px_rgba(249,115,22,0.7)] hover:scale-105" data-id="element-105">
          Empezar ahora
        </a>
      </div>
    </motion.nav>;
}